import {Form} from '../../../app/components/Form';
import {useGetBiotwinQuery, useUpdateBiotwinMutation} from '../../../app/services/biotwinApi';
import {useBlockUI} from '../../core/hooks/useBlockUI';
export interface ManageDemoProps {
  className?: string;
  userId: number;
}
export const ManageDemo = ({className, userId}: ManageDemoProps) => {
  const [updateBiotwin, {isLoading: isLoadingUpdateBiotwin}] = useUpdateBiotwinMutation();
  const {data: biotwin} = useGetBiotwinQuery(
    {
      id: userId,
    },
    {
      skip: !userId,
    },
  );
  useBlockUI(isLoadingUpdateBiotwin);
  return (
    <Form
      className={className}
      defaultValues={biotwin}
      fields={({setValue}) => [
        {
          name: 'isDemo',
          label: 'Demo',
          type: 'checkbox',
          typeOptions: {
            onCheckedChange: (e) => {
              setValue('isDemo', !!e);
              updateBiotwin({
                id: userId,
                changes: {
                  isDemo: e === true,
                },
              })
                .unwrap()
                .catch(() => {
                  setValue('isDemo', !e);
                });
            },
          },
        },
      ]}
      submitButton={false}
    />
  );
};
